import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

import { UserregComponent } from './userreg/userreg.component';


@Component({
	selector: 'app-user',
	templateUrl: './user.component.html',
	styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

	pageObj:any = "curr";

	frm : FormGroup;

	logi_user:any;
	userList:any;

	/* 페이징 */
	cp:any = 1;
	paging:any = [];
	paging_start:any = [];
	paging_end:any = [];

	total_cnt:any = 0;

	/* 검색관련 */
	skey:any = "";
	sw:any = "";

	constructor(
		private http: HttpClient,
		public dialog: MatDialog,
		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = new FormGroup({
			skey: new FormControl(''),
			sw: new FormControl('')
		});
	}

	ngOnInit() {
		this.cp = this.func.getParameterByName("page", window.location.href);
		if( this.cp == null ){ this.cp = 1; }

		this.skey = this.func.getParameterByName("skey", window.location.href);
		if( this.skey == null ){ this.skey = ""; }

		this.sw = this.func.getParameterByName("sw", window.location.href);
		if( this.sw == null ){ this.sw = ""; }

		this.getUserList(this.cp);
	}

	async getUserList(num) {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);
		formData.append("page", num);
		formData.append("skey", this.skey);
		formData.append("sw", this.sw);

		this.http.post(this.env.API_URL + 'api/auser.list.php', formData).subscribe((response) => {
			this.userList = response['list'];
			this.paging = response['paging']['pnum'];
			this.paging_start = response['paging']['start'];
			this.paging_end = response['paging']['end'];

			this.total_cnt = response['total_cnt'];
		});
	}

	async userWrite() {
		const dialogRef = this.dialog.open(UserregComponent,{
			panelClass: '',
			width: "420px",
			data: {
			},
		});

		dialogRef.afterClosed().subscribe(result => {
		});
	}

	/*
	async delConfirm(idx) {
		const dialogRef = this.dialog.open(DelComponent,{
			panelClass: 'confirm-class',
			width: "280px",
			data: {
				title: '거래처 삭제',
				message: '해당 거래처를 삭제하시겠습니까? 삭제된 내용은 복구하실 수 없습니다.',
				idx: idx
			},
		});

		dialogRef.afterClosed().subscribe(result => {
			this.partnerDel(result);
		});
	}
	*/

	async partnerDel(idx) {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("idx", idx);

		this.http.post(this.env.API_URL + 'api/partner.delete.php', formData).subscribe((response) => {
			this.getUserList(1);
		});
	}

	schForm(form) {
		let sc_params = "";

		this.skey = form.value.skey;
		this.sw = form.value.sw;
		if( this.skey ){ sc_params += "&skey="+this.skey; }
		if( this.sw )
		{
			sc_params += "&sw="+this.sw;
		}

		history.pushState(null, document.title, window.location.pathname+"?page=1"+sc_params);
		this.getUserList(1);
	}


	selectPage( num, ev ) {
		this.getUserList(num);
		this.cp = num;

		let sc_params = "";

		if( this.skey ){ sc_params += "&skey="+this.skey; }
		if( this.sw ){ sc_params += "&sw="+this.sw; }

		history.pushState(null, document.title, window.location.pathname+"?page="+num+sc_params);
	}
}
